<template>
	<!-- Notice we bind :options="chartOptions" and :series="chartOptions.series" -->
	<apexchart :options="chartOptions" :series="chartOptions.series" :type="chartType" height="350" />
</template>

<script>
	import { defineComponent } from "vue"
	import VueApexCharts from "vue3-apexcharts"

	export default defineComponent({
		name: "AdminChart",
		components: {
			apexchart: VueApexCharts,
		},
		props: {
			data: {
				// e.g. [{ label: 'English (US)', value: 8 }, { label: 'French', value: 2 }]
				type: Array,
				default: () => [],
			},
			chartType: {
				type: String,
				default: "pie",
			},
			title: {
				type: String,
				default: "",
			},
		},
		computed: {
			chartOptions() {
				// Separate labels & values from the input data
				const labels = this.data.map((item) => item.label)
				const values = this.data.map((item) => item.value)

				const baseOptions = {
					chart: {
						type: this.chartType,
						background: "transparent",
						toolbar: { show: true },
					},
					colors: [
						"#1F77B4",
						"#FF7F0E",
						"#2CA02C",
						"#D62728",
						"#9467BD",
						"#8C564B",
						"#E377C2",
						"#7F7F7F",
						"#BCBD22",
						"#17BECF",
					],
					theme: {
						mode: "dark",
					},
					legend: {
						position: "left",
						labels: { colors: "#fff" },
					},
					tooltip: {
						theme: "dark",
					},
				}

				if (["pie", "donut", "radialBar"].includes(this.chartType)) {
					return {
						...baseOptions,
						labels,
						series: values,
					}
				} else {
					return {
						...baseOptions,
						xaxis: {
							categories: labels,
							labels: { style: { colors: "#fff" } },
						},
						series: [
							{
								name: "Count",
								data: values,
							},
						],
					}
				}
			},
		},
	})
</script>

<style>
	.apexcharts-toolbar {
		margin-top: -42px !important;
	}
</style>
